export default {"src":"/_next/static/media/pdf-doc.af0d795e.svg","height":40,"width":40};